import React from 'react';
import { cn } from '@Utils';

interface SpinnerProps {
  className?: string;
}

const Spinner: React.FC<SpinnerProps> = ({ className }) => {
  return (
    <div className="grid place-content-center w-full">
      <div
        className={cn(
          'size-6 animate-spin rounded-full border-solid border-2 border-current border-r-transparent text-brand-500 ease-in',
          className,
        )}
        role="status"
        aria-label="loading"
      />
    </div>
  );
};

export default Spinner;
